module.exports = {"610703001":"汉山街道","610703002":"中所营街道","610703101":"圣水镇","610703102":"大河坎镇","610703103":"协税镇","610703104":"梁山镇","610703105":"阳春镇","610703106":"高台镇","610703107":"新集镇","610703108":"濂水镇","610703109":"黄官镇","610703110":"青树镇","610703111":"红庙镇","610703112":"牟家坝镇","610703113":"法镇","610703114":"湘水镇","610703115":"小南海镇","610703116":"碑坝镇","610703117":"黎坪镇","610703118":"福成镇","610703119":"两河镇","610703120":"胡家营镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/610703.json
// module id = 2986
// module chunks = 0